<template>
    <ProgressSpinner style="width: 20px; height: 20px" strokeWidth="4" fill="transparent"
    animationDuration=".5s" aria-label="Custom ProgressSpinner" />
</template>
